

export function iniClicksLoading(d = document) {
	let as = d.querySelectorAll('a:not([target="_blank"],a[href^="#"])');
	for (var a of as) {
		a.addEventListener('click', e => {
			if (!e.ctrlKey && !e.metaKey) {
				addLoading(e, d);
			}
		});
	}
}
export function iniClicksLoadingHeader() {
	let as = document.querySelectorAll(
		['header.header a:not([target="_blank"],a[href^="#"])','.submenus-wrapper-desktop a:not([target="_blank"],a[href^="#"])']
	);
	for (var a of as) {
		a.addEventListener('click', e => {
			if (!e.ctrlKey && !e.metaKey) {
				addLoading(e, document);
			}
		});
	}
}

function addLoading(e,d){
    const dur = 0.3;
    gsap.to(d.querySelector('#app'), {
        duration: dur,
        autoAlpha: 0,
        ease: 'Power2.easeOut',
    });
    
}